<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Price List Data Manager</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" small text to="/price-lists">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <!-- editor -->
        <editor :priceList="priceList" :docCreate="docCreate" :initial="dataItem" @data="save"></editor>
        <!-- end -->
      </v-card-text>
    </v-card>

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
import Editor from "../_components/manage-editor.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    Editor
  },
  computed: {
    ...mapGetters(["user"])
  },
  data: () => ({
    dataItem: {},
    priceList: null,
    docCreate: false
  }),
  watch: {
    "$route.params.id": {
      handler: "getPriceList",
      immediate: true
    }
  },
  methods: {
    getPriceList(val) {
       const self = this;
      this.priceList = val;
      this.$store
        .dispatch("get", `/manual-buying-prices/${val}`)
        .then(res => {
          console.log(res);
          if (res.ResultCode == 1200) {
            var priceList = res.ResponseData;
            var itm4 = res.ResponseData["rows"];
            var details = {
              id: priceList["id"],
              Name: priceList["Name"],
              itm4: itm4
            };
            self.dataItem = details;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    save(data) {
      const url = `/import-pricelist`;
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$router.push("/price-lists");
            self.$store.commit("btnLoader", false);
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.$store.commit("btnLoader", false);
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  }
};
</script>